import styles from "../styles/FilterComponents.module.scss";
import XIcon from "../../../components/icons/filters/xIcon";
import { CSSTransition } from "react-transition-group";
import { useTranslation } from "react-i18next";

interface IProps {
  clearFiltersHandler: () => void;
  hideBtn?: boolean;
}
const ClearButton = ({ clearFiltersHandler, hideBtn }: IProps) => {
  const { i18n } = useTranslation();
  const dirData = i18n.language === 'ar' ? 'rtl' : 'ltr';
  const { t } = useTranslation();

  return (
    <div
      className={styles.clearButtonWrap}
      dir={dirData}
    >
      <CSSTransition
        in={!hideBtn}
        timeout={300}
        classNames={{
          enter: styles.fadeEnter,
          enterActive: styles.fadeEnterActive,
          exit: styles.fadeExit,
          exitActive: styles.fadeExitActive,
        }}
        unmountOnExit
      >
        <div onClick={clearFiltersHandler} className={styles.clearFiltersButton} dir={dirData}>
          <XIcon />
          {t("Clear")}
        </div>
      </CSSTransition>
    </div>
  );
};

export default ClearButton;
